import React from 'react';
import { useGeneralHooks } from '../../../../../../Hooks/hooks';
import { ICategoryAction, MenuListTypes } from '../../../../../../Interfaces/componentTypes';
import { IMenuListItem } from '../../../../../../Interfaces/responseTypes';
import useDragnDropHooks from '../../../../../../Hooks/dragndrop-hook';
import { Drag } from '../../../../../../Assets/Icons';
import styles from './categoryCard.module.scss';

export interface IProps {
    data: IMenuListItem;
    title: string;
    image: string;
    onClick?: () => void;
    type: MenuListTypes;
    actions?: ICategoryAction[] | [];
    order_list?: number[];
    onOrderChange?: (updatedOrder: number[]) => void;
}

const PrimaryCategoryCard: React.FC<IProps> = (props) => {
    const {
        data,
        onClick = () => { },
        type,
        actions = [],
        title,
        image,
        order_list,
        onOrderChange,
    } = props;
    const { baseURL, mobileScreen } = useGeneralHooks();
    const { cardRef, isDragging, isDraggable, handleDrag, dragEndHandler, dropHandler, dragOverHandler, dragStartHandler, handleIconMouseDown, handleIconMouseUp } = useDragnDropHooks(order_list!, onOrderChange!)

    return (
        <div
            ref={cardRef}
            id={String(data.category.id)}
            className={`${styles.cardBox} ${isDragging ? styles.dragging : ''}`}
            draggable={isDraggable && type === MenuListTypes.EDIT}
            onDragStart={(e) => dragStartHandler(e, data.category)}
            onDragEnd={dragEndHandler}
            onDragOver={dragOverHandler}
            onDrop={order_list ? (e) => dropHandler(e, data.category.id) : undefined}
            onDrag={handleDrag}
            onClick={onClick}
        >
            <div
                className={type === MenuListTypes.EDIT ? styles.cardEdit : styles.cardView}
                onClick={onClick}
            >
                <div
                    className={styles.cardImage}
                    style={{ backgroundImage: `url(${baseURL}${image})` }}
                >
                    <div className={styles.cardTitle}>
                        <p>{title}</p>
                    </div>
                </div>
            </div>
            {type === MenuListTypes.EDIT && (
                <div className={styles.cardActionBox}>
                    {actions.map((action, index) => (
                        <div
                            key={index}
                            onClick={() => action.onClick(data, title)}
                            className={styles.actionIconBox}
                        >
                            <img src={action.icon} alt="icon" />
                        </div>
                    ))}
                    {
                        !mobileScreen
                        &&
                        <div
                            className={styles.actionIconBox}
                            onMouseDown={handleIconMouseDown}
                            onMouseUp={handleIconMouseUp}
                        >
                            <img src={Drag} alt="icon" />
                        </div>
                    }
                </div>
            )}
        </div>
    );
};

export default PrimaryCategoryCard;
